import { Injectable } from '@angular/core';
import { databases, ID, storage } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Especialidad } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EspecialidadesService {

  private collectionId = "t_especialidades";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }

   /**
   * @getData()
   * @returns
   */
   getData(): Promise<Especialidad[]> {
    return databases.listDocuments<Especialidad>(
      this.DATABASE_NAME,
      this.collectionId
    ).then(response => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: Especialidad) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }




  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDocuments(idEspecialista: string): Promise<Especialidad[]> {
    return databases.listDocuments<Especialidad>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('idEspecialista', [idEspecialista])]
    ).then(response => response.documents);
  }

  /**
   * @deleteDocument()
   * @param fileId
   * @returns
   */
  deleteDocument(documentId: string) {
    return databases.deleteDocument(this.DATABASE_NAME, this.collectionId, documentId);
  }
}
